import { useGithub } from '../../hooks/useGithub';
import { Avatar, Button, Grid, Stack, Typography } from '@mui/material';
import { BuildingIcon, EnvelopeIcon, LocationIcon } from '../../utils/icons';
import { SOCIAL_MEDIA_LINKS } from '../../utils/constants';
import React from 'react';

function IconText({ Icon, text }) {
    return (
        <Grid container alignItems="center" gap={1} sx={{ fontSize: '0.875rem' }}>
            <Grid item sx={{ display: 'flex', alignItems: 'center', flexBasis: 'auto' }}>
                <Icon />
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center', flexBasis: 'auto' }}>
                <Typography
                    variant="h6"
                    sx={{ color: '#f4f4f4', fontFamily: 'inherit', fontSize: '0.875rem' }}
                >
                    {text}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default function UserCard() {
    const { user } = useGithub();

    return user ? (
        <Stack container spacing={2} sx={{ pt: 5 }}>
            <Avatar
                src={user.avatarUrl}
                alt={user.username}
                sx={{
                    width: 300,
                    height: 300,
                    border: '2px solid #3a4149' // Adds a solid outline
                }}
            />
            <Typography
                variant="h6"
                sx={{ color: '#858c95', fontWeight: 100, fontFamily: 'inherit' }}
            >
                {user.username}{' · he/him'}
            </Typography>
            <Button
                onClick={() => window.open(SOCIAL_MEDIA_LINKS.email, '_blank')}
                sx={{
                    width: '100%',
                    textAlign: 'center',
                    borderRadius: '8px',
                    fontFamily: 'inherit',
                    border: '1px solid #3d444d',
                    textTransform: 'none',
                    backgroundColor: '#212830',
                    color: 'white',
                    padding: '4px 4px',
                    height: 'auto',
                    '&:hover': {
                        backgroundColor: '#262c36' // Change background color on hover
                    }
                }}
            >
                Email
            </Button>
            <IconText Icon={BuildingIcon} text={user.company} />
            <IconText Icon={LocationIcon} text={user.location} />
            {
                user.email !== null ?? (
                    <IconText Icon={EnvelopeIcon} text={user.email} />
                )
            }
        </Stack>
    ) : null;
}